<template>
  <div
    id="splash"
    class="d-flex justify-center align-center"
    style="height: 100vh"
  >
    <v-img
      contain
      lazy-src="../../assets/img/logo-teman-bakat.png"
      max-height="150"
      max-width="250"
      src="../../assets/img/logo-teman-bakat.png"
    ></v-img>
  </div>
</template>

<script>
export default {
  name: "Splash",
};
</script>

<style></style>
